import { http } from "./http";

export type CustomerReviewItem = {
  appointmentId: string;
  establishmentId: string;
  establishmentName: string;
  establishmentSlug: string;
  providerId: string | null;
  providerName: string | null;
  serviceName: string | null;
  scheduledAt: string;
  status: string;
  reviewRequestedAt: string | null;
  reviewedAt: string | null;
  rating: number | null;
  reviewComment: string | null;
  canReview: boolean;
};

export type CustomerReviewsSummary = {
  pendingCount: number;
  submittedCount: number;
  averageGivenRating: number | null;
};

export type CustomerReviewsResponse = {
  ok: true;
  summary: CustomerReviewsSummary;
  pending: CustomerReviewItem[];
  submitted: CustomerReviewItem[];
};

export type CustomerReviewSubmitResponse = {
  ok: true;
  review: {
    appointmentId: string;
    rating: number;
    comment: string | null;
    providerRating?: {
      providerId: string;
      providerName: string | null;
      averageRating: number | null;
      reviewsCount: number;
    } | null;
  };
};

export function getCustomerReviews(
  token: string,
  params?: {
    establishmentId?: string;
    status?: "pending" | "submitted" | "all";
  }
) {
  const query: Record<string, string> = {};
  if (params?.establishmentId) query.establishmentId = params.establishmentId;
  if (params?.status) query.status = params.status;
  return http<CustomerReviewsResponse>("/customer/reviews", { token, query });
}

export function submitCustomerReview(
  token: string,
  appointmentId: string,
  payload: { rating: number; comment?: string }
) {
  return http<CustomerReviewSubmitResponse>(
    `/customer/appointments/${appointmentId}/review`,
    {
      method: "POST",
      token,
      body: payload,
    }
  );
}
